import {
    Component,
    EventEmitter,
    HostListener, Inject,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild, ElementRef
} from '@angular/core';
import {DataService, SignalTypes} from 'projects/firebase/src/lib/services/data.service';
import {Router} from '@angular/router';
import {EyeTrackerService} from 'projects/eye-tracker/src/lib/eye-tracker.service';
import {delay, map, Subject, Subscription} from 'rxjs';
import {AuthService} from 'projects/firebase/src/lib/services/auth.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {
    IStopTestConfig,
    StopTestConfirmationModalComponent
} from 'projects/eye-tracker/src/lib/stop-test-confirmation-modal/stop-test-confirmation-modal.component';
import {TimerService} from '../timer.service';
import {DOCUMENT} from '@angular/common';

export interface IVisualConfig {
    downloadText: string;
    willStart: string;
    uploadingText: string;
    readingInfo: string;
}

interface DocumentWithFullscreen extends HTMLDocument {
    mozFullScreenElement?: Element;
    msFullscreenElement?: Element;
    webkitFullscreenElement?: Element;
    msExitFullscreen?: () => void;
    mozCancelFullScreen?: () => void;
    webkitExitFullscreen?: () => void;
}

@Component({
    selector: 'lib-visual-test',
    templateUrl: './visual-test.component.html',
    styleUrls: ['./visual-test.component.scss'],

})
export class VisualTestComponent implements OnInit, OnDestroy {
    @Input() environment;
    @Input() isEng = false;

    @Input() testId: any;
    @Input() sid: any;
    @Input() uid: any;
    @Input() config: IVisualConfig = {
        downloadText: 'Downloading test',
        willStart: 'Test will start automatically after downloading complete',
        uploadingText: 'Uploading test data',
        readingInfo: '<b>Текст пояснює</b>, що відбувається під час тесту та яке зображення потрібно вибрати.',
    };
    @Input() stopTestConfig: IStopTestConfig = {
        title: 'Are you sure you want to suspend the test?',
        text: 'If you want to suspend the test &mdash; no payment will be charged, and you will be redirected to the main page.',
        continueText: 'Proceed',
        stopText: 'Suspend'
    };
    @Input() gazefilter: any;
    public desiredElement: ElementRef;
    @ViewChild('wrapper') wrapper: ElementRef;

    @ViewChild('lImg') lImg: ElementRef;
    @ViewChild('rImg') rImg: ElementRef;


    @ViewChild('text') text: ElementRef;
    @ViewChild('i1') i1: ElementRef;
    @ViewChild('i2') i2: ElementRef;

    @ViewChild('lImgWrapper') lImgWrapper: ElementRef;
    @ViewChild('rImgWrapper') rImgWrapper: ElementRef;


    @ViewChild('lText') lText: ElementRef;
    @ViewChild('rText') rText: ElementRef;

    @ViewChild('dot') dot: ElementRef;
    @Output() testEnd: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() errorEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

    filter: Blob;
    event: Blob;

    timeOfTesting = 0;
    steps: any[] = [];
    step: any | null = null;
    currentStepIndex = -1;

    key: any;

    timeout: any;
    $isActive = false;
    loading = true;
    uploading = false;
    manual = false;

    params = {
        event: {bufferSize: 200},
        filter: {bufferSize: 480}
    };

    extensions: any = {
        filter: '.csv',
        event: '.json',
        mouse: '.csv',
        webcam: '.mp4',
    };

    point: { x: number, y: number } = {x: 0, y: 0};

    isStartConfirmed = false;
    leftImage: any;
    rightImage: any;
    imageSetLoaded = false;
    filterEvent: Subscription;

    totalImagesLoaded = 0;
    isPaused = false;

    updatePoint: Subject<any> = new Subject<any>();
    amountOfAdditionalCalibrationPoints = 3;
    isFullScreen = false;
    isReading = false;

    articleImages = [];
    articleLoadedImages = [];

    imageData: any = {};
    selectedImg: any = null;
    private isDetected = true;
    private resumeTimerTimeout;
    protected defaultCalibrationPoints = 3;

    @HostListener('window:keydown', ['$event'])
    keyEvent(event: KeyboardEvent) {
        this.escapeKey(event);
    }

    // @HostListener('document:fullscreenchange', ['$event'])
    // fullscreenmodes(event: any) {
    //     console.log(document.fullscreenEnabled);
    //     if (document.fullscreenEnabled) {
    //         console.log('onStopTesting');
    //         this.onStopTesting();
    //     } else {
    //         console.log('not full');
    //     }
    // }


    constructor(
        private service: EyeTrackerService,
        private dataService: DataService,
        private modalService: NgbModal,
        private auth: AuthService,
        private router: Router,
        private timer: TimerService,
        @Inject(DOCUMENT) private document: any
    ) {
        this.detectErrors();
    }

    chkScreenMode() {
        this.isFullScreen = document.fullscreenEnabled;
    }

    async ngOnInit() {
        this.chkScreenMode();

        const prefixes = ['', 'moz', 'webkit', 'ms'];
        const doc = document as DocumentWithFullscreen;
        const fullscreenElement = doc.fullscreenElement || /* Standard syntax */
            doc.webkitFullscreenElement || /* Chrome, Safari and Opera syntax */
            doc.mozFullScreenElement || /* Firefox syntax */
            doc.msFullscreenElement /* IE/Edge syntax */;

        prefixes.forEach((prefix) => {
            document.addEventListener(prefix + 'fullscreenchange', (res) => {
                    if (this.detected && this.isActive && !this.isPaused) {
                        // this.isPaused = true;
                        // this.onStopTesting();
                    }
                }
            );
        });

        this.loading = true;
        if (this.testId) {
            this.initTest(this.testId);
        }
    }

    ngOnDestroy() {
        const prefixes = ['', 'moz', 'webkit', 'ms'];
        prefixes.forEach((prefix) => {
            removeEventListener(prefix + 'fullscreenchange', () => {
            });
        });

        if (typeof this.filterEvent !== 'undefined') {
            this.filterEvent.unsubscribe();
        }
    }

    detectErrors() {
        const detectionEvents = [];
        const add = (prop) => {
            if (detectionEvents.length > 3) {
                detectionEvents.shift();
            }
            detectionEvents.push(prop);

            return detectionEvents;
        };
        this.service.filter()
            .subscribe((res: any) => {
                if (!this.isActive) {
                    return;
                }
                const sumRes = add(res);
                if (sumRes.every(el => !!el) && !this.detected) {
                    this.detected = true;
                    this.resume();
                }

                if (sumRes.every(el => !el && this.detected)) {
                    this.detected = false;
                    this.pause();
                }

            });
    }

    pause() {
        this.isPaused = true;
        this.resumeTimerTimeout = this.timeout;
        this.timer.stop();
        if (this.isActive && this.gazefilter && this.gazefilter.recorder && !this.gazefilter.recorder.isPaused()) {
            this.gazefilter.recorder.toggle();
        }
    }

    resume() {
        this.isPaused = false;
        const step = this.steps[this.currentStepIndex];

        if (this.isActive && this.gazefilter && this.gazefilter.recorder && this.gazefilter.recorder.isPaused()) {
            this.gazefilter.recorder.toggle();
            if (!this.isReading) {
                this.initTimer(step);
            }
        }
    }

    get detected() {
        return this.isDetected;
    }

    set detected(prop) {
        this.isDetected = prop;
    }

    onStartConfirmed() {
        this.isStartConfirmed = true;
    }

    initTest(testId: string) {
        this.loading = true;
        this.dataService.getScenario(this.service.apiUrl, testId)
            .pipe(
                // delay(3000),
                map(((res: { test: string, scenes: any[] }) => {
                    this.isReading = res.test === 'concussion';
                    this.steps = res.scenes;
                    const totalTime = this.steps.reduce((partialSum, a) => partialSum + a.interval, 0) / 1000;
                    this.timeOfTesting = Math.round(totalTime / 60);
                    return res;
                }))
            )
            .subscribe((res) => {
                this.loading = false;
                this.preloadImages(this.steps);

            }, (err) => {
                this.loading = false;
            });
    }

    preloadImages(steps: any[]) {
        for (const item of steps) {
            if (item.type === SignalTypes.ImageSet) {

                const lSrc: string = item.assets.find((img: any) => img.id === item.data.l)?.url + '?fm=jpg&fit=crop&w=600&h=600';
                const rSrc: string = item.assets.find((img: any) => img.id === item.data.r)?.url + '?fm=jpg&fit=crop&w=600&h=600';

                item.data.l_src = {src: lSrc};
                item.data.r_src = {src: rSrc};
            }
            if (item.type === SignalTypes.Action) {
                item.data.i1 = {src: `${this.service.getApiUrl()}/storage/content/${item.data.l}`};
                item.data.i2 = {src: `${this.service.getApiUrl()}/storage/content/${item.data.r}`};
            }
            if (item.type === SignalTypes.Article) {
                item.images = item.images.map((el: string) => {
                    return {
                        src: `${this.service.getApiUrl()}/storage/content/${el}`,
                        id: el
                    };
                });
                // item.data.i1 = {src: `${this.service.getApiUrl()}/storage/content/${item.images[0]}`};
                // item.data.i2 = {src: `${this.service.getApiUrl()}/storage/content/${item.images[1]}`};
                // item.data.i3 = {src: `${this.service.getApiUrl()}/storage/content/${item.images[3]}`};
            }
        }
        this.onStart()
            .then();
    }

    getImageHeight(images: any[]) {
        return Math.round(100 / images.length);
    }

    async onImgLoad(el, slideType, target) {
        const index = this.currentStepIndex;
        const step = this.steps[index];
        this.step = step;
        this.imageSetLoaded = false;
        let actionData = {};
        const outerGap = .6;
        const innerGap = .5;
        switch (slideType) {
            case 'imageSet':
                this.leftImage = target === 1 ? el : this.leftImage;
                this.rightImage = target === 2 ? el : this.rightImage;
                if (target === 1) {
                    await this.setMaxImageSize(this.lImgWrapper.nativeElement, outerGap, innerGap);
                }
                if (target === 2) {
                    await this.setMaxImageSize(this.rImgWrapper.nativeElement, innerGap, outerGap);
                }

                if (this.leftImage && this.rightImage) {
                    this.imageSetLoaded = true;
                    const l = this.lImg.nativeElement;
                    const r = this.rImg.nativeElement;
                    const {x, y} = this.lImg.nativeElement.getBoundingClientRect();
                    const imageSetData = {
                        l: {
                            x: l.offsetLeft,
                            y: l.offsetTop,
                            width: l.width,
                            height: l.height,
                            id: step.data.l
                        },
                        r: {
                            x: r.offsetLeft,
                            y: r.offsetTop,
                            width: r.width,
                            height: r.height,
                            id: step.data.r
                        },
                    };
                    this.onSlideActive(step, index, imageSetData, actionData);
                    this.leftImage = null;
                    this.rightImage = null;
                    this.initTimer(step);
                }
                break;
            case 'empty':
                actionData = {
                    position: step.position
                };
                this.onSlideActive(step, index, null, actionData);
                this.initTimer(step);
                break;
            case 'action':
                this.leftImage = target === 1 ? el : this.leftImage;
                this.rightImage = target === 2 ? el : this.rightImage;

                if (this.leftImage && this.rightImage) {
                    this.imageSetLoaded = true;
                    const i1 = this.i1.nativeElement;
                    const i2 = this.i2.nativeElement;
                    const text = this.text.nativeElement;
                    const textBox = this.text.nativeElement.getBoundingClientRect();

                    const imageSetData = {
                        i1: {
                            x: i1.offsetLeft,
                            y: i1.offsetTop,
                            width: i1.width,
                            height: i1.height,
                            id: step.data.l
                        },
                        i2: {
                            x: i2.offsetLeft,
                            y: i2.offsetTop,
                            width: i2.width,
                            height: i2.height,
                            id: step.data.r
                        },
                        text: {
                            x: text.offsetLeft,
                            y: text.offsetTop,
                            width: textBox.width,
                            height: textBox.height,
                        },
                    };
                    this.onSlideActive(step, index, imageSetData, actionData);
                    this.leftImage = null;
                    this.rightImage = null;
                }
                break;
            case 'article':
                this.articleLoadedImages.push(target);
                const img: any = document.getElementById('x' + target);
                this.imageData[this.articleImages[target].id] = {
                    x: img.offsetLeft,
                    y: img.offsetTop,
                    width: img.offsetWidth,
                    height: img.offsetHeight,
                    id: this.articleImages[target].id
                };
                const text: any = document.getElementById('text');
                this.imageData.text = {
                    x: text.offsetLeft,
                    y: text.offsetTop,
                    width: text.offsetWidth,
                    height: text.offsetHeight,
                    rows: this.calculateTextRows(text),
                    content: this.steps[this.currentStepIndex]?.article?.document
                };
                if (this.articleLoadedImages.length === this.articleImages.length) {
                    this.imageSetLoaded = true;
                    this.onSlideActive(step, index, this.imageData, actionData);
                }
                break;
            default:
                break;
        }
    }

    setMaxImageSize(img, leftGap, rightGap) {
        const ww = window.innerWidth / 2;
        const imageWidth = ww / (1 + leftGap + rightGap);
        img.style.paddingLeft = imageWidth * leftGap + 'px';
        img.style.paddingRight = imageWidth * rightGap + 'px';
        return new Promise((resolve) => resolve(img));
    }

    onSlideActive(step, index, imageSetData, actionData?) {
        this.emitData(step, index, imageSetData, actionData);
    }

    onIndexChanged() {
        this.step = this.steps[this.currentStepIndex];
        if (this.step.type === SignalTypes.Article) {
            this.imageSetLoaded = false;
            this.articleImages = [];
            this.articleLoadedImages = [];
            this.articleImages = this.step.images;
        }
    }

    emitData(step: any, i: number, imageSetData: any, actionData: any) {
        this.gazefilter.recorder.pushEvent(
            new Event('').timeStamp,
            'signal_change',
            step?.type,
            {
                sceneData: {
                    index: i,
                    sceneId: step.id,
                    imageSetData,
                    actionData
                }
            },
        );
    }

    initTimer(step: any) {
        const imageSetDelay = localStorage.getItem('imageSetDelay') || step.interval;
        const textDelay = localStorage.getItem('textDelay') || step.interval;
        const emptyDelay = localStorage.getItem('crossDelay') || step.interval;
        const actionDelay = localStorage.getItem('circleDelay') || step.interval;
        const slidedDlay = (s) => {
            switch (s.type) {
                case 'imageSet':
                    return +imageSetDelay;
                case 'text':
                    return +textDelay;
                case 'empty':
                    return +emptyDelay;
                default:
                    return +actionDelay;
            }
        };
        this.timer.start(() => {
            return this.onTimerEnd(step);
        }, slidedDlay(step));
    }

    onTimerEnd(step) {
        if (step?.type === SignalTypes.Action || step?.type === SignalTypes.NoAction) {
            // const dot = this.dot.nativeElement.getBoundingClientRect();
            // this.gazefilter.tracker.calibrate(
            //   new Event('').timeStamp,
            //   dot.x + 20,
            //   dot.y + 20,
            //   1
            // );

        }
        const next = this.currentStepIndex + 1;
        if (!this.isPaused) {
            this.goNext(next);
        }
    }

    onActionClick(answer: any) {
        const step = this.steps[this.currentStepIndex];
        this.onSlideActive(step, this.currentStepIndex, null, {
            answer: answer.id
        });
        this.goNext(this.currentStepIndex + 1);
    }

    onImgSelected(img: any) {
        if (this.selectedImg?.id === img.id) {
            this.selectedImg = null;
        } else {
            this.selectedImg = img;
        }
    }

    goNext(index: number) {
        this.currentStepIndex = index;
        this.imageData = {};
        if (this.steps.length > this.currentStepIndex) {
            this.onIndexChanged();
        } else {
            this.gazefilter.recorder.stop().then(this.handleStopRecording.bind(this));
        }
    }

    onStopTesting() {
        this.pause();
        const modalRef = this.modalService.open(StopTestConfirmationModalComponent, {
            centered: true,
            windowClass: 'modal modal-stop',
            backdrop: 'static',
            keyboard: true
        });
        modalRef.componentInstance.isEng = this.isEng;
        modalRef.componentInstance.config = this.stopTestConfig;
        return modalRef.result
            .then((res) => {
                if (res) {
                    if (this.timer.started) {
                        this.timer.stop();
                    }
                    this.gazefilter.recorder.stop()
                        .then(() => {
                            return this.router.navigate(['/'], {});
                        })
                        .then(() => {
                            window.location.reload();
                        });
                } else {
                    this.service.fullScreen(true)
                        .then(() => {
                            this.resume();
                        });
                }
            }, () => {
                this.resume();
            });

    }

    shiftKey(event: any) {
        event.preventDefault();
        if (!this.isActive) {
            return;
        }
        if (event.key.toLowerCase() === 'shift' && (this.step?.type === SignalTypes.Action || this.step?.type === SignalTypes.NoAction)) {
            this.gazefilter.recorder.pushEvent(
                new Event('').timeStamp,
                'action',
                this.step?.type,
                {
                    correctAction: this.step.position === event.location && this.step?.type === SignalTypes.Action,
                    timeout: false
                }
            );
        }

    }

    escapeKey(event: any) {
        if (this.detected && event.key.toLowerCase() === 'escape') {
            this.onStopTesting();
        }
    }

    get isActive() {
        return this.$isActive && this.steps[this.currentStepIndex]?.type;
    }

    set isActive(prop) {
        this.$isActive = prop;
    }

    async onStart() {
        await this.onstart(this.params);
        this.isActive = true;
        this.goNext(0);
    }

    onCalibration() {
    }

    onFixation(prop) {
        const fixationPoint = prop.fixationPoint();
        const x = fixationPoint[0];
        const y = fixationPoint[1];
        if (!isNaN(x) && !isNaN(y) && this.steps[this.currentStepIndex]?.type === 'empty') {
            this.point.x = x;
            this.point.y = y;
        }
    }

    handleStopRecording(data: { filter: any, event: any }) {
        this.uploading = true;
        this.isActive = false;
        // noinspection JSVoidFunctionReturnValueUsed
        this.gazefilter.tracker.dispose()
            .then(() => this.onStop(data))
            .then(() => this.service.waitUntil(1000))
            .then(() => this.service.fullScreen(false))
            .then(() => this.router.navigate(['s', this.sid, 'q']))
            .then(() => {
                this.uploading = false;
            })
            .finally();
    }

    async uploadBatch(source: any, blob: any) {
        const now = performance.now();
        const ext: any = this.extensions[source];
        const nsOrigin = (performance.timeOrigin * 1000).toFixed();
        const nsNow = (now * 1000).toFixed();

        const filename = `${nsOrigin}-${nsNow}${ext}`;
        const path = `users/${this.auth.userData.uid}/sessions/${this.sid}/${source}/${filename}`;

        await this.dataService.uploadBlob(path, blob);
    }

    onbatch(type: any, blob: any) {
        return this.uploadBatch(type, blob);
    }

    async onstart(detail: any) {
        if (this.gazefilter && (!this.gazefilter.recorder.isActive() || this.gazefilter.recorder.isPaused())) {
            this.gazefilter.recorder.start(
                detail,
                this.onbatch.bind(this)
            );
        }
        const nsOrigin = (performance.timeOrigin * 1000).toFixed();
        const data = {
            timeOrigin: nsOrigin,
            screen: {
                width: screen?.width,
                height: screen?.height
            },
            window: {
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight,
                outerHeight: window.outerHeight,
                outerWidth: window.outerWidth,
            }
        };

        await this.gazefilter.recorder.pushEvent(performance.now(), 'recorder', 'metadata', detail);
        return this.gazefilter.recorder.pushEvent(performance.now(), 'recorder', 'screen', data);

    }

    async onStop(detail: any) {
        const promises = Object
            .entries(detail)
            .map(([type, blob]) => {
                return this.uploadBatch(type, blob);
            });
        await Promise.all(promises);
    }

    calculateTextRows(div: any) {
        // Get the computed style of the div to access the line height
        const style = window.getComputedStyle(div);

        // Get the height of the div
        const divHeight = div.clientHeight;

        // Get the line height (parse to remove 'px' if present)
        const lineHeight = parseFloat(style.lineHeight);

        // Calculate and return the number of rows
        return Math.round(divHeight / lineHeight);
    }

    onbeforeunload(): any {
        // if (this.gazefilter.recorder.isActive()) {
        //   event.preventDefault();
        //   return event.returnValue = '';
        // }
    }
}
